export default 
[
  {
    id: 0, 
    nome: 'Aluno'
  },
  {
    id: 1, 
    nome: 'Professor'
  },
  {
    id: 2, 
    nome: 'Técnico'
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/tipos-quadro.js